import { useMemo } from 'react';
import { useField } from 'formik';
import ReactSelect from 'react-select';

import { FormikField } from 'types';
import { controlError } from 'utils';

import { Container } from './styles';
import { SelectProps } from './types';
import { useSelectStyles } from './helpers';

export const Select = ({
  label,
  error,
  options,
  onChange,
  placeholder,
  maxMenuHeight,
  containerStyle,
  ...props
}: SelectProps) => {
  const styles = useSelectStyles({ error, maxHeight: maxMenuHeight });

  return (
    <Container error={error} style={{ ...containerStyle }}>
      {label && <p>{label}</p>}
      <ReactSelect
        styles={styles}
        options={options}
        onChange={onChange}
        isSearchable={false}
        menuPosition="fixed"
        placeholder={placeholder}
        {...props}
      />
    </Container>
  );
};

export const SelectField = ({
  name,
  options,
  ...props
}: FormikField<SelectProps>) => {
  const [field, meta, helpers] = useField(name);

  const value = useMemo(() => {
    if (options && options.length > 0) {
      const index = options?.findIndex((item) => item.label === field.value);
      return options[index];
    }

    return field.value;
  }, [options, field.value]);

  const error = controlError(meta, name, props.label);

  return (
    <Select
      value={value}
      error={error}
      options={options}
      onChange={(option) => {
        // @ts-ignore
        helpers.setValue(option.value);
      }}
      {...props}
    />
  );
};
